import { Injectable, EventEmitter, Inject } from "@angular/core";
import { GoogleAddress, AddressSourceEnum } from "../../../analytics/dataModels/staticReports.data-models";
import { Configuration } from "../../configurations/shared.config";
import { HttpService } from "../http.service";
import { IErrorHandlerToken, IErrorHandler } from "../../dataModels";

declare var ol: any;
declare var google: any;

@Injectable()
export class MapAddress {
    addressLoaded: EventEmitter<GoogleAddress> = new EventEmitter<GoogleAddress>();

    constructor(private http: HttpService, @Inject(IErrorHandlerToken) private _errorHandler: IErrorHandler) { }

    public GetMapAddress(lat: number, lng: number, returnedData: any, propertyName?: string, saveAddressfn?: any): Promise<any> {
        if (Configuration.addressService.useGoogleAddress) {
            let geocoder = new google.maps.Geocoder();
            var point = { lat: lat, lng: lng };
            return new Promise((resolve, reject) => {
                geocoder.geocode({ 'location': point }, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0] != null) {
                            this.setReturnedAddress(lat, lng, results[0].formatted_address, returnedData, propertyName, saveAddressfn);
                        }
                    }

                    else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                        //resolve(null);
                        setTimeout(() => {
                            this.GetMapAddress(lat, lng, returnedData, propertyName, saveAddressfn);
                        }, 1000);
                    }
                });
            });
        }
        else if (Configuration.addressService.useEsriAddress) {
            //// dont remove last slash from url, it will not work
            this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetEsriAddress + "/" + lat + "/" + lng + "/", null, false).map(res => res.json())
                .subscribe(res => {
                    if (res.IsErrorState) {
                        this._errorHandler.DefaultError();
                    }
                    else {
                        this.setReturnedAddress(lat, lng, res.Value, returnedData, propertyName, saveAddressfn);
                    }
                });
        }
    }

    public SaveGoogleAddress(addresses: GoogleAddress[]) {
        if (Configuration.addressService.saveAddressInCassandra) {
            let addressSource = -1;

            if (Configuration.addressService.useGoogleAddress) {
                addressSource = AddressSourceEnum.Google;
            }
            else if (Configuration.addressService.useEsriAddress) {
                addressSource = AddressSourceEnum.Esri;
            }

            return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.SaveAddress + "/" + addressSource, addresses, null, false).map(res => res.json()).toPromise();
        }
        else {
            return Promise.resolve({ IsErrorState: false, Value: true, ErrorDescription: null, ErrorMetadata: null });
        }
    }

    public GetAddress(cordinates: GoogleAddress[]) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.GetAddress, cordinates).map(res => res.json());
    }

    private setReturnedAddress(lat: number, lng: number, address: string, returnedData: any, propertyName?: string, saveAddressfn?: any) {
        if (propertyName) {
            returnedData[propertyName] = address;
        }
        else {
            returnedData = address;
        }

        if (saveAddressfn) saveAddressfn(lat, lng, address);
        this.addressLoaded.emit({ lon: lng, lat: lat, Address: address });
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/maps/map-address.service.ts